module.exports = __webpack_public_path__ + "img/banner4.087ff10e.png";